import type { FC } from "react";
import styles from "./Header.module.css";
import { ProgressBar } from "../ProgressBar";
import { CloseIcon, ChevronLeftIcon } from "../Icons";
import Button from "../UI/Button";
import { useModalManager } from "@/hooks";
import { ExitModal } from "../ExitModal";
import { PricesRecap } from "../PricesRecap";

interface HeaderProps {
  onClose?: () => void;
  onBack?: () => void;
  backAvailable?: boolean;
  showProgress?: boolean;
}

export const Header: FC<HeaderProps> = ({
  onClose,
  onBack,
  backAvailable,
  showProgress,
}) => {
  const confirmationExitModal = useModalManager("confirmation-exit");

  const handleClose = () => {
    confirmationExitModal.open(
      <ExitModal
        onCancel={() => confirmationExitModal.close()}
        onConfirm={() => {
          confirmationExitModal.close();
          if (onClose) {
            onClose();
          }
        }}
      />,
      "auto",
    );
  };

  return (
    <header className={styles.header}>
      <div className={styles.topRow}>
        <div className={styles.backNavigation}>
          {backAvailable && (
            <button
              type="button"
              onClick={onBack}
              className={styles.backButton}
              aria-hidden="true"
              aria-label="Back"
            >
              <ChevronLeftIcon size={22} color="text" />
            </button>
          )}
        </div>
        {showProgress && <ProgressBar />}
        <Button
          type="button"
          onClick={handleClose}
          className={styles.closeButton}
          aria-label="Close"
          variant="ghost"
        >
          <CloseIcon size={22} color="text" />
        </Button>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.backNavigationMobile}>
          {backAvailable && (
            <button
              type="button"
              onClick={onBack}
              className={styles.backButton}
              aria-hidden="true"
              aria-label="Back"
            >
              <ChevronLeftIcon size={22} color="text" />
            </button>
          )}
        </div>
        <div className={styles.pricesWrapper}>
          <PricesRecap />
        </div>
        <Button
          type="button"
          onClick={handleClose}
          className={styles.closeButtonMobile}
          aria-label="Close"
          variant="ghost"
        >
          <CloseIcon size={22} color="text" />
        </Button>
      </div>
    </header>
  );
};
